import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MunicipalityWiseBorrow from './borough/municipalityWiseBorrow';
import { API_URLS } from '../../apiUrl';
import { Pagination } from '@mui/material';
import axiosInstance from '../../components/axiosInstance';
import { useMunicipality } from '../../components/MunicipalityContext';

const ViewMunicipality = () => {

  const [isBoroughView, setIsBoroughView] = useState(false);
  const [tableData, setTableData] = useState<any>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [municipalityId, setMunicipalityId] = useState<any>("");
  const [municipalityName, setMunicipalityName] = useState<any>("");

  const { resetMunicipality, setResetMunicipality } = useMunicipality();

  const [inputData, setInputData] = useState({ page: 1, limit: 50 });
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage] = useState(50);

  const handleClick = (id: any, municipalityName: any) => {
    setMunicipalityId(id);
    setIsBoroughView(true);
    setMunicipalityName(municipalityName);
  };

 useEffect(() => {
    if (resetMunicipality) {
      setIsBoroughView(false);
      setMunicipalityId("");
      setMunicipalityName("");
      setResetMunicipality(false); 
    }
  }, [resetMunicipality]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.post(`${API_URLS.MunicipalityList}`, {
          page: inputData.page,
          limit: inputData.limit
        }
      );

        if (response.data && response.data.data.data) {
          setTableData(response.data.data.data); 
          setTotalItems(response.data.data.total);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [inputData.page]);

  const filteredData = tableData?.filter((item: any) =>
    item.municipality_name?.toLowerCase().trim().includes(searchQuery.toLowerCase().trim()) ||
    item.admin_name?.toLowerCase().trim().includes(searchQuery.toLowerCase().trim()) ||
    item.login_user_name?.toLowerCase().trim().includes(searchQuery.toLowerCase().trim())
  );

  const navigate = useNavigate();
  const navigateToEditpage = (municipalityId: any, logo: any) => {
    navigate('/dashboard/edit-profile', {
      state: { getMunicipalityIdFromSuperAdmin: municipalityId, logo: logo }
    });
  };

  const handlePageChange = (event: any, value: number) => {
    setInputData((prevData) => ({
      ...prevData,
      page: value,  
    }));
  };

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  return (
    <>
      {isBoroughView ? (
        <MunicipalityWiseBorrow
          breadCrumb={setIsBoroughView}
          municipalityId={municipalityId}
          municipalityName={municipalityName}
        />
      ) : (
        <div className="container mx-auto">
          <div className="flex gap-5 mb-4">
            <h1 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">Municipality Administration</h1>
            <div className="flex justify-end md:w-4/12 w-full ml-auto">
              <input
                type="text"
                placeholder="Search..."
                className="border px-3 py-2 rounded-lg w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-900 dark:bg-gray-800"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          <div className="overflow-x-auto bg-white rounded-lg shadow-lg border border-gray-200 dark:border-gray-800">
            <table className="min-w-full table-auto">
              <thead className="bg-gray-100 border-b dark:border-gray-600 dark:bg-gray-700">
                <tr>
                  <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Municipality Name</th>
                  <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Admin Name</th>
                  <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Username</th>
                  <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Borough</th>
                  <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredData?.length < 1 ? (
                  <tr>
                    <td colSpan={5} className="py-3 px-6 text-center dark:bg-gray-800">No results found</td>
                  </tr>
                ) :
                filteredData?.map((item: any, index: any) => (
                  <tr key={index} className="border-b dark:border-gray-700 hover:bg-gray-50">
                    <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.municipality_name}</td>
                    <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.admin_name}</td>
                    <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.login_user_name}</td>
                    <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">
                      <button onClick={() => handleClick(item.primary_id, item.municipality_name)} className="ml-2">
                        <img src="/assets/boroughIcon.png" alt="Icon" className="w-5 h-5" />
                      </button>
                    </td>
                    <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600 text-center">
                      <div className="flex gap-2">
                        <button onClick={() => navigateToEditpage(item.primary_id, item.logo)}
                          className="px-2 py-1.5 text-green-500 border border-green-200 rounded bg-green-100 hover:bg-green-200"
                        >
                          <i className="ri-edit-line"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {filteredData?.length === 0 ? null :
            <div className="flex justify-center mt-4">
              <Pagination
                count={totalPages}  
                page={inputData.page}
                onChange={handlePageChange}
                color="primary"
              />
            </div>}
        </div>
      )}
    </>
  );
};

export default ViewMunicipality;